function fix(fixele) {
    let scrollTop = fixele.scrollTop;
    fixele.style.cssText = `position:fixed;overflow:hidden`;
    fixele.scrollTop = scrollTop;
}

function unfix(fixele) {
    let scrollTop = fixele.scrollTop;
    fixele.style.cssText = `position:'';overflow:''`;
    fixele.scrollTop = scrollTop;
}
export { fix, unfix }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/fix_ele.js